import { HeroSection } from "@/components/HeroSection";
import { ClientsSection } from "@/components/ClientsSection";

const HomePage = () => {
  return (
    <>
      {/* Hero Section - Full screen */}
      <HeroSection />

      {/* Clients Section - directly after the hero, before the footer */}
      <ClientsSection />
    </>
  );
};

export default HomePage;
